// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__OV3aT","approved":"Status_approved__2qyCO","rejected":"Status_rejected__2CVgf","expired":"Status_expired__3-b0G","label":"Status_label__3kU2O"};